import { api } from './api';

class AssessmentService {
  // Fetch assessments for a specific module
  async fetchModuleAssessments(userId, courseId, moduleId) {
    console.log('🔍 DEBUG: assessmentService.fetchModuleAssessments called with:', { userId, courseId, moduleId });
    try {
      const response = await api.getStudentAssessments({ module_id: moduleId, assessment_type: 'module' });
      console.log('🔍 DEBUG: API response:', response);
      const allAssessments = response.data?.items || [];
      console.log('🔍 DEBUG: All assessments from API:', allAssessments);

      // Process assessments to match test format
      return allAssessments.map(assessment => ({
        id: assessment.id,
        title: assessment.title || 'Module Assessment',
        description: assessment.description,
        status: assessment.status,
        isCompleted: assessment.status === 'evaluated',
        maxMarks: assessment.max_marks,
        marksAwarded: assessment.marks_awarded,
        endDate: assessment.end_date,
        remainingSeconds: assessment.remaining_seconds,
        assessmentType: 'Module Assessment',
        moduleId: assessment.module_id,
        courseId: courseId,
        userId: userId,
        submission: assessment.submission,
        assignment_payload: {
          assessment_id: assessment.id,
          module_id: assessment.module_id,
          course_id: courseId,
          user_id: userId
        }
      }));
    } catch (error) {
      console.error('Error fetching module assessments:', error);
      return [];
    }
  }

  // Fetch assessments for a specific lesson
  async fetchLessonAssessments(userId, courseId, lessonId) {
    console.log('🔍 DEBUG: assessmentService.fetchLessonAssessments called with:', { userId, courseId, lessonId });
    try {
      const response = await api.getStudentAssessments({ lesson_id: lessonId, assessment_type: 'lesson' });
      const allAssessments = response.data?.items || [];
      console.log('🔍 DEBUG: Filtered lesson assessments:', allAssessments);

      // Process assessments to match test format
      return allAssessments.map(assessment => ({
        id: assessment.id,
        title: assessment.title || 'Lesson Assessment',
        description: assessment.description,
        status: assessment.status,
        isCompleted: assessment.status === 'evaluated',
        maxMarks: assessment.max_marks,
        marksAwarded: assessment.marks_awarded,
        endDate: assessment.end_date,
        remainingSeconds: assessment.remaining_seconds,
        assessmentType: 'Lesson Assessment',
        lessonId: assessment.lesson_id,
        moduleId: assessment.module_id,
        courseId: courseId,
        userId: userId,
        submission: assessment.submission,
        assignment_payload: {
          assessment_id: assessment.id,
          lesson_id: assessment.lesson_id,
          module_id: assessment.module_id,
          course_id: courseId,
          user_id: userId
        }
      }));
    } catch (error) {
      console.error('Error fetching lesson assessments:', error);
      return [];
    }
  }

  // Fetch assessments for a specific topic
  async fetchTopicAssessments(userId, courseId, lessonId, topicId) {
    console.log('🔍 DEBUG: assessmentService.fetchTopicAssessments called with:', { userId, courseId, lessonId, topicId });
    try {
      const response = await api.getStudentAssessments({ topic_id: topicId, assessment_type: 'topic' });
      const allAssessments = response.data?.items || [];
      console.log('🔍 DEBUG: Filtered topic assessments:', allAssessments);

      // Process assessments to match test format
      return allAssessments.map(assessment => ({
        id: assessment.id,
        title: assessment.title || 'Topic Assessment',
        description: assessment.description,
        status: assessment.status,
        isCompleted: assessment.status === 'evaluated',
        maxMarks: assessment.max_marks,
        marksAwarded: assessment.marks_awarded,
        endDate: assessment.end_date,
        remainingSeconds: assessment.remaining_seconds,
        assessmentType: 'Topic Assessment',
        topicId: assessment.topic_id,
        lessonId: assessment.lesson_id,
        moduleId: assessment.module_id,
        courseId: courseId,
        userId: userId,
        submission: assessment.submission,
        assignment_payload: {
          assessment_id: assessment.id,
          topic_id: assessment.topic_id,
          lesson_id: assessment.lesson_id,
          module_id: assessment.module_id,
          course_id: courseId,
          user_id: userId
        }
      }));
    } catch (error) {
      console.error('Error fetching topic assessments:', error);
      return [];
    }
  }

  // Fetch assessments for specific content
  async fetchContentAssessments(userId, courseId, contentId) {
    console.log('🔍 DEBUG: assessmentService.fetchContentAssessments called with:', { userId, courseId, contentId });
    try {
      const response = await api.getStudentAssessments({ content_id: contentId, assessment_type: 'content' });
      const allAssessments = response.data?.items || [];
      console.log('🔍 DEBUG: Filtered content assessments:', allAssessments);

      // Process assessments to match test format
      return allAssessments.map(assessment => ({
        id: assessment.id,
        title: assessment.title || 'Content Assessment',
        description: assessment.description,
        status: assessment.status,
        isCompleted: assessment.status === 'evaluated',
        maxMarks: assessment.max_marks,
        marksAwarded: assessment.marks_awarded,
        endDate: assessment.end_date,
        remainingSeconds: assessment.remaining_seconds,
        assessmentType: 'Content Assessment',
        contentId: assessment.content_id,
        topicId: assessment.topic_id,
        lessonId: assessment.lesson_id,
        moduleId: assessment.module_id,
        courseId: courseId,
        userId: userId,
        submission: assessment.submission,
        assignment_payload: {
          assessment_id: assessment.id,
          content_id: assessment.content_id,
          topic_id: assessment.topic_id,
          lesson_id: assessment.lesson_id,
          module_id: assessment.module_id,
          course_id: courseId,
          user_id: userId
        }
      }));
    } catch (error) {
      console.error('Error fetching content assessments:', error);
      return [];
    }
  }

  // Get assessment details
  async getAssessmentDetails(assessmentId) {
    try {
      const response = await api.getStudentAssessment(assessmentId);
      return response.data;
    } catch (error) {
      console.error('Error fetching assessment details:', error);
      return null;
    }
  }
}

const assessmentService = new AssessmentService();
export default assessmentService;
